module.exports = __webpack_public_path__ + "static/1061636586.9d87a5a1.jpg";